/**
 * The on-screen keyboard (mobile A07). iOS keeps the layout viewport under the keyboard, so a bottom sheet or the fixed
 * primary-action bar sinks behind it. The covered height goes to `--kb` on <html> (CSSOM, CSP-safe): app.css lifts the
 * sheets and `.page-cta` by it, and a focused field inside a dialog is scrolled back into view. Android with
 * interactive-widget=resizes-content and desktop report 0, so nothing moves there. Once, from main.ts.
 */
export function trackKeyboard(): void {
  const vv = window.visualViewport;
  if (!vv) return;
  const sync = (): number => {
    // a pinch-zoomed page also shrinks the visual viewport — that is not a keyboard
    const kb = vv.scale > 1 ? 0 : Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    document.documentElement.style.setProperty('--kb', `${kb}px`);
    return kb;
  };
  vv.addEventListener('scroll', sync);
  vv.addEventListener('resize', () => {
    if (sync() && document.activeElement?.closest('dialog')) document.activeElement.scrollIntoView({ block: 'center' });
  });
}
